
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-portal/support",
      function () {
        return require("private-next-pages/community-portal/support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-portal/support"])
      });
    }
  